import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SlotController } from "@/common/controllers/slot";
import { when } from "@/index";
import EkoElement from "@/utilities/element";
import style from "./card-header.css?inline";

@customElement("eko-card-header")
export class CardHeader extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private collapseSlot = new SlotController(this, "collapse");

  @property({ reflect: true, type: Boolean }) admin: boolean = false;
  @property({ reflect: true }) padding: "lg" | "md" | "sm" = "md";

  render() {
    return html`<div class="eko-card-header" collapse=${when(this.collapseSlot.tagName)}>
      <div class="eko-card-header__container">
        <div class="eko-card-header__content">
          <slot></slot>
          ${this.admin ? html`<eko-admin-icon tooltip></eko-admin-icon>` : nothing}
          <slot name="append"></slot>
        </div>
        <slot name="collapse"></slot>
      </div>
      <slot name="after"></slot>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-card-header": CardHeader;
  }
}

export default CardHeader;
